import React from "react";
import '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faReact, faDocker, faPython } from '@fortawesome/free-brands-svg-icons';
import Chip from '@mui/material/Chip';
import '../assets/styles/Expertise.scss';

const labelsFirst = [
    "FORTINET",
    "SOPHOS",
    "CISCO",
    "PFSENSE",
    "DELL",
    "HUWAWEI",
    "SANGFOR",
    "Azure",
    "AWS",
    "Windows Server",
    "Linux Server"
];

const labelsSecond = [
    "CCNA",
    "MCSA,MCSE,",
    "Azure , AWS , GCP",
    "ProxMox VE , Hyber-V , VMware",
    "CCNP Enterprise Core",
    "CCNP Security",
    "Linux",
    "NSE4,NSE5 - FCP",
    "CEH",
];

const labelsThird = [
    "PNETLab",
    "EVE-NG",
    "GNS3",
    "OPNET , CML",
    "VMWare Workstation , Hyber-V , Virtual Box",
    "Docker",
    "Cloud Platforms: Azure , AWS , GCP",
];

function Expertise() {
    return (
    <div className="container" id="expertise">
        <div className="skills-container">
            <h1>Expertise</h1>
            <div className="skills-grid">
                <div className="skill">
                    <FontAwesomeIcon icon={faReact} size="3x"/>
                    <h3>"Information Security Manager · Network & Security Architect · Trainer"</h3>
                    <p>Designing and securing multi-site enterprise network architectures using Layer 3 cores, segmentation, firewall zoning,
 SD-WAN connectivity, and integrated protection layers including NGFW, ZTNA, VPN gateways, and EDR/XDR platforms, and training cybersecurity professionals.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsFirst.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faDocker} size="3x"/>
                    <h3>Enterprise Network Architectures</h3>
                    <p>Building multi-site network topologies using Layer 3 cores, segmentation, firewall zoning, SD-WAN connectivity, and secure routing models.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsSecond.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>

                <div className="skill">
                    <FontAwesomeIcon icon={faPython} size="3x"/>
                    <h3>HCI & Virtualization Platforms</h3>
                    <p>Designing secure data center network architectures for HCI and virtualization environments, including core–aggregation–access network topology, segmented networks for management, storage, and tenant traffic, high-availability switching, and secure firewall zoning for VMware and HCI clusters integrated with enterprise SAN storage and resilient backup platforms.</p>
                    <div className="flex-chips">
                        <span className="chip-title">Tech stack:</span>
                        {labelsThird.map((label, index) => (
                            <Chip key={index} className='chip' label={label} />
                        ))}
                    </div>
                </div>
            </div>
        </div>
    </div>
    );
}

export default Expertise;